import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  moveResultId: null
};

const moveResultModalSlice = createSlice({
  name: 'moveResultModal',
  initialState,
  reducers: {
    openMoveResultModal: (state, action) => {
      state.isOpen = true;
      state.moveResultId = action.payload; // payload should be moveResultId string
    },
    closeMoveResultModal: (state) => {
      state.isOpen = false;
      state.moveResultId = null;
    }
  }
});

export const { openMoveResultModal, closeMoveResultModal } = moveResultModalSlice.actions;
export default moveResultModalSlice.reducer;


